import { Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getSpacing } from 'stylesheet';

export const StyledFullScreenLoaderContainer = styled(Dialog)(({ theme }) => ({
  //Keep the blocking loader above every app Dialog, which sits at theme.zIndex.modal
  zIndex: theme.zIndex.modal + 10,
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
  '& .MuiDialog-paper': {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    //Define width and height to avoid overflow
    width: getSpacing(6),
    height: getSpacing(6),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
